import { BaseNote } from './base-note.dto';
import { SubProject } from './sub-project.dto';

export class SubProjectNote extends BaseNote {
  subProject?: SubProject;
}
